module.exports = __webpack_public_path__ + "media/pistolhit.7d79db15.wav";